(function () {
  // Initialize all collapsible tabs with metafield content
  function initCollapsibleTab(blockId) {
    const tabElement = document.querySelector(
      ".x-block-collapsible-tab-" + blockId
    );
    if (!tabElement) return;

    // Function to check if content has meaningful body content (not just headings)
    const hasBodyContent = function (element) {
      if (!element) return false;

      // Get all text content first
      const textContent = element.innerText || element.textContent || "";
      const trimmedText = textContent.trim();

      // If completely empty, return false
      if (trimmedText.length === 0) {
        // Check for images, tables, etc. even if no text
        const hasMedia =
          element.querySelectorAll("img, table, iframe, video, canvas").length >
          0;
        return hasMedia;
      }

      // Get all headings
      const headings = element.querySelectorAll("h1, h2, h3, h4, h5, h6");
      let headingText = "";
      headings.forEach(function (h) {
        headingText += (h.innerText || h.textContent || "") + " ";
      });
      headingText = headingText.trim();

      // If the text content is only from headings, it's "only title"
      if (headingText.length > 0 && trimmedText.trim() === headingText.trim()) {
        return false;
      }

      // Check for body content elements (not just headings)
      const bodyElements = element.querySelectorAll(
        "p, ul, ol, li, img, table, iframe, video, canvas, blockquote, pre, code"
      );
      if (bodyElements.length > 0) {
        // Check if any body element has actual content
        for (let i = 0; i < bodyElements.length; i++) {
          const el = bodyElements[i];
          // For media elements, they count as content
          if (
            el.tagName === "IMG" ||
            el.tagName === "TABLE" ||
            el.tagName === "IFRAME" ||
            el.tagName === "VIDEO" ||
            el.tagName === "CANVAS"
          ) {
            return true;
          }
          // For text elements, check if they have content
          const innerText = el.innerText || el.textContent || "";
          if (innerText.trim().length > 0) {
            return true;
          }
        }
      }

      // If there's text beyond headings, it has body content
      if (trimmedText.length > headingText.length) {
        return true;
      }

      return false;
    };

    // Initial check: if there's no content div and no meaningful data-html elements, hide immediately
    const initialContentDiv = tabElement.querySelector(".rte");
    if (!initialContentDiv) {
      const initialHtmlElements = tabElement.querySelectorAll("[data-html]");

      // If no data-html elements at all, hide immediately
      if (initialHtmlElements.length === 0) {
        tabElement.style.display = "none";
        return;
      }

      let hasInitialContent = false;
      for (let i = 0; i < initialHtmlElements.length; i++) {
        const html = initialHtmlElements[i].dataset.html;
        // Check if HTML exists and has content (not just whitespace or empty)
        if (html && html.trim().length > 0) {
          // Decode to check if it has meaningful content
          const decoded = html
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&amp;/g, "&");
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = decoded;
          // Check if it has body content (not just headings)
          if (hasBodyContent(tempDiv)) {
            hasInitialContent = true;
            break;
          }
        }
      }
      // If no meaningful content found, hide the tab
      if (!hasInitialContent) {
        tabElement.style.display = "none";
        return;
      }
    } else {
      // Even if content div exists, check if it's empty or only has headings
      const initialHtmlElements =
        initialContentDiv.querySelectorAll("[data-html]");
      // If there are data-html elements, wait for them to render before checking
      if (initialHtmlElements.length === 0) {
        // No data-html elements, so check if content has body content (not just headings)
        if (!hasBodyContent(initialContentDiv)) {
          tabElement.style.display = "none";
          return;
        }
      } else {
        // Check if data-html elements have any content
        let hasDataHtmlContent = false;
        for (let i = 0; i < initialHtmlElements.length; i++) {
          const html = initialHtmlElements[i].dataset.html;
          if (html && html.trim().length > 0) {
            hasDataHtmlContent = true;
            break;
          }
        }
        // If data-html elements exist but are all empty, hide immediately
        if (!hasDataHtmlContent) {
          tabElement.style.display = "none";
          return;
        }
      }
      // If there are data-html elements with content, let renderHTML handle it
    }

    // Function to clean up excessive <br> tags - keep max 2 consecutive
    const cleanupBrTags = function (element) {
      if (!element) return;
      let html = element.innerHTML;
      let prevHtml = "";
      let maxIterations = 20;
      let iteration = 0;
      while (html !== prevHtml && iteration < maxIterations) {
        prevHtml = html;
        // Replace any sequence of 3+ consecutive <br> tags (any format) with exactly 2 <br> tags
        html = html.replace(
          /(<br\s*\/?\s*>(?:\s*<br\s*\/?\s*>){2,})/gi,
          "<br><br>"
        );
        iteration++;
      }
      if (html !== element.innerHTML) {
        element.innerHTML = html;
      }
    };

    // Function to check if content is empty after rendering
    const checkAndHideEmptyTab = function () {
      const contentDiv = tabElement.querySelector(".rte");

      // If there's no content div, check for data-html elements at tab level
      if (!contentDiv) {
        // Check for any data-html elements anywhere in the tab
        const htmlElements = tabElement.querySelectorAll("[data-html]");
        let hasContent = false;

        // If no data-html elements at all, definitely hide
        if (htmlElements.length === 0) {
          tabElement.style.display = "none";
          return;
        }

        for (let i = 0; i < htmlElements.length; i++) {
          const html = htmlElements[i].dataset.html;
          // Check if HTML exists and has content (not just whitespace or empty)
          if (html && html.trim().length > 0) {
            // Decode to check actual content
            const decoded = html
              .replace(/&lt;/g, "<")
              .replace(/&gt;/g, ">")
              .replace(/&amp;/g, "&");
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = decoded;
            // Check if it has body content (not just headings)
            if (hasBodyContent(tempDiv)) {
              hasContent = true;
              break;
            }
          }
        }
        // If no meaningful data-html content, hide the tab
        if (!hasContent) {
          tabElement.style.display = "none";
        }
        return;
      }

      // First, check if there are any elements with data-html that haven't been rendered yet
      const unrenderedElements = contentDiv.querySelectorAll(
        '[data-html]:not([data-rendered="true"])'
      );
      if (unrenderedElements.length > 0) {
        // Content is still being rendered, don't hide yet
        return;
      }

      // Check if there's HTML content waiting to be rendered in data-html attributes
      const htmlElements = contentDiv.querySelectorAll("[data-html]");
      let hasPendingContent = false;

      if (htmlElements.length > 0) {
        for (let i = 0; i < htmlElements.length; i++) {
          const html = htmlElements[i].dataset.html;
          // Check if HTML exists and has content (not just whitespace)
          if (html && html.trim().length > 0) {
            // Decode to check if it has meaningful content
            const decoded = html
              .replace(/&lt;/g, "<")
              .replace(/&gt;/g, ">")
              .replace(/&amp;/g, "&");
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = decoded;
            // Check if it has body content (not just headings)
            if (hasBodyContent(tempDiv)) {
              // There's meaningful body content waiting to be rendered, don't hide
              hasPendingContent = true;
              break;
            }
          }
        }
      }

      // If no pending content in data-html, check rendered content
      if (!hasPendingContent) {
        // Check if rendered content has body content (not just headings)
        if (!hasBodyContent(contentDiv)) {
          tabElement.style.display = "none";
        }
      }
    };

    const renderHTML = function () {
      const els = document.querySelectorAll(
        ".metafield-html-content-" + blockId
      );
      els.forEach(function (el) {
        if (el && el.dataset.html) {
          let html = el.dataset.html;

          // Check if HTML is empty or just whitespace
          if (!html || html.trim().length === 0) {
            el.dataset.rendered = "true";
            return;
          }

          // Decode HTML entities
          html = html
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/&amp;/g, "&");

          // Check if decoded HTML is empty
          const tempCheckDiv = document.createElement("div");
          tempCheckDiv.innerHTML = html;
          const checkText =
            tempCheckDiv.innerText || tempCheckDiv.textContent || "";
          if (
            checkText.trim().length === 0 &&
            tempCheckDiv.querySelectorAll("img, table, iframe, video, canvas")
              .length === 0
          ) {
            el.dataset.rendered = "true";
            return;
          }

          // Clean up excessive <br> tags - keep max 2 consecutive <br> tags
          let prevHtml = "";
          let maxIterations = 20;
          let iteration = 0;
          while (html !== prevHtml && iteration < maxIterations) {
            prevHtml = html;
            // Replace any sequence of 3+ consecutive <br> tags (any format) with exactly 2 <br> tags
            html = html.replace(
              /(<br\s*\/?\s*>(?:\s*<br\s*\/?\s*>){2,})/gi,
              "<br><br>"
            );
            iteration++;
          }

          el.innerHTML = html;
          el.dataset.rendered = "true";

          // Clean up the rendered content again
          cleanupBrTags(el);
        }
      });

      // Also clean up any directly rendered rich text metafield content
      const contentDiv = tabElement.querySelector(".rte");
      if (contentDiv) {
        cleanupBrTags(contentDiv);
      }
      // Check if content is empty after cleanup (with delay to ensure rendering is complete)
      setTimeout(checkAndHideEmptyTab, 100);
    };

    // Check if tab is open by default
    const isOpenByDefault =
      tabElement.hasAttribute("x-data") &&
      tabElement.getAttribute("x-data").includes("open: true");
    if (isOpenByDefault) {
      setTimeout(renderHTML, 100);
    }

    // Watch for tab open/close
    const observer = new MutationObserver(function (mutations) {
      const contentDiv = tabElement.querySelector('[x-show="open"]');
      if (
        contentDiv &&
        !contentDiv.hasAttribute("x-cloak") &&
        contentDiv.offsetParent !== null
      ) {
        setTimeout(renderHTML, 100);
      }
    });

    observer.observe(tabElement, {
      attributes: true,
      attributeFilter: ["x-cloak"],
      childList: true,
      subtree: true,
    });

    // Also listen for click events on the button
    const button = tabElement.querySelector("button");
    if (button) {
      button.addEventListener("click", function () {
        setTimeout(renderHTML, 150);
      });
    }

    // Immediate check (runs right away)
    checkAndHideEmptyTab();

    // Clean up on initial load for directly rendered rich text metafields
    setTimeout(function () {
      // First render HTML content from data-html attributes
      renderHTML();
      // Then clean up and check after rendering is complete
      setTimeout(function () {
        const contentDiv = tabElement.querySelector(".rte");
        if (contentDiv) {
          cleanupBrTags(contentDiv);
        }
        // Check and hide even if there's no contentDiv (function handles it)
        checkAndHideEmptyTab();
      }, 150);
    }, 200);

    // Additional cleanup after a longer delay to catch any late-rendered content
    setTimeout(function () {
      // Make sure renderHTML has run first
      renderHTML();
      setTimeout(function () {
        const contentDiv = tabElement.querySelector(".rte");
        if (contentDiv) {
          cleanupBrTags(contentDiv);
        }
        // Check and hide even if there's no contentDiv (function handles it)
        checkAndHideEmptyTab();
      }, 100);
    }, 500);
  }

  // Initialize tabs on page load
  document.addEventListener("DOMContentLoaded", function () {
    const tabElements = document.querySelectorAll("[data-collapsible-tab-id]");
    tabElements.forEach(function (tab) {
      const blockId = tab.getAttribute("data-collapsible-tab-id");
      if (blockId) {
        initCollapsibleTab(blockId);
      }
    });
  });

  // Also support manual initialization
  window.initCollapsibleTab = initCollapsibleTab;
})();

